import * as PIXI from 'pixi.js';
function logPixiSettings() {
    console.log(`%cPIXI Settings:`, 'color: #88AACC');
    Object.keys(PIXI.settings).forEach((settingName) => {
        let settingValue = PIXI.settings[settingName];
        if (typeof settingValue === 'object') {
            settingValue = JSON.stringify(settingValue);
        }
        else if (typeof settingValue === 'function') {
            settingValue = 'fn';
        }
        console.log(`%c${settingName}: ${settingValue}`, 'color: #88AACC');
    });
}
export function initPixiSettings(instanceId) {
    // TODO: Change any needed PIXI settings from defaults here.
    // TODO: Set PIXI.settings.RESOLUTION = window.devicePixelRatio to improve performance on retina displays,
    // but handle scaling correctly and switching between differing DPI monitors while playing.
    // Even if it's determined that this is a "low performance" device, don't crash:
    PIXI.settings.FAIL_IF_MAJOR_PERFORMANCE_CAVEAT = false;
    if (instanceId === 0) {
        logPixiSettings();
    }
}
export function getAnimationCount(instanceId) {
    const tickerCount = window.pixiApps?.[instanceId]?.ticker.count;
    return tickerCount !== undefined ? tickerCount : -1;
}
